import type { BadgeFontWeight } from "sharedTypes/badge"

export const BADGE_FONTS = {
  Arial: "Arial",
  Georgia: "Georgia",
  CourierNew: "Courier New",
  Verdana: "Verdana",
  Impact: "Impact",
} as const

export type BadgeFontType = (typeof BADGE_FONTS)[keyof typeof BADGE_FONTS]
export const BADGE_FONT_VALUES = Object.values(BADGE_FONTS)

export const BADGE_FONT_WEIGHTS = {
  Thin: 100,
  ExtraLight: 200,
  Light: 300,
  Regular: 400,
  Medium: 500,
  SemiBold: 600,
  Bold: 700,
  ExtraBold: 800,
  Black: 900,
} as const

export const BADGE_FONT_WEIGHT_OPTIONS = [
  { label: "Thin", value: BADGE_FONT_WEIGHTS.Thin },
  { label: "Extra Light", value: BADGE_FONT_WEIGHTS.ExtraLight },
  { label: "Light", value: BADGE_FONT_WEIGHTS.Light },
  { label: "Regular", value: BADGE_FONT_WEIGHTS.Regular },
  { label: "Medium", value: BADGE_FONT_WEIGHTS.Medium },
  { label: "Semi Bold", value: BADGE_FONT_WEIGHTS.SemiBold },
  { label: "Bold", value: BADGE_FONT_WEIGHTS.Bold },
  { label: "Extra Bold", value: BADGE_FONT_WEIGHTS.ExtraBold },
  { label: "Black", value: BADGE_FONT_WEIGHTS.Black },
]

export const BADGE_FONT_SUPPORTED_WEIGHTS: Record<BadgeFontType, BadgeFontWeight[]> = {
  Arial: [BADGE_FONT_WEIGHTS.Regular, BADGE_FONT_WEIGHTS.Bold],
  Georgia: [BADGE_FONT_WEIGHTS.Regular, BADGE_FONT_WEIGHTS.Bold],
  "Courier New": [BADGE_FONT_WEIGHTS.Regular, BADGE_FONT_WEIGHTS.Bold],
  Verdana: [BADGE_FONT_WEIGHTS.Regular, BADGE_FONT_WEIGHTS.Bold],
  Impact: [BADGE_FONT_WEIGHTS.Regular],
}
